export default "__VITE_ASSET__CW4kQ_nH__"